/* Stella Quilt Wall: the page script (sections/stella-quilt-wall.liquid).
   Works on its own: the still poster, the shade chips and the side panel need nothing else.
   When the section scrolls into view on a device that can draw it, it loads the 3D rail
   (assets/stella-quilt-wall-3d.js, three.js r160 bundled), waits for its first frame,
   and fades it in over the poster. If the 3D cannot run, or runs too slowly, the poster stays. */
(() => {
  const root = document.querySelector('[data-sqw]');
  if (!root || root.dataset.sqwReady) return;
  root.dataset.sqwReady = '1';
  const $ = sel => root.querySelector(sel);
  const data = JSON.parse($('[data-sqw-data]').textContent);
  const shades = data.shades;
  const N = shades.length;
  const pad = n => String(n).padStart(2, '0');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const debug = /[?&]sqw-debug\b/.test(location.search);
  // local QC only: some preview panes report a visible page as hidden
  const forceVisible = debug && /[?&]sqw-visible\b/.test(location.search);
  const isHidden = () => document.hidden && !forceVisible;

  const stage = $('.sqw__stage');
  const poster = $('.sqw__poster');
  const panel = $('.sqw__panel');
  const chips = [...root.querySelectorAll('.sqw__chip')];
  const caption = $('.sqw__caption'), capNum = $('.sqw__caption-num'), capName = $('.sqw__caption-name');
  const hint = $('.sqw__hint');
  const el = {
    count: $('[data-p="count"]'), name: $('[data-p="name"]'), note: $('[data-p="note"]'),
    close: $('[data-p="close"]'), bed: $('[data-p="bed"]'), bedCap: $('[data-p="bedcap"]'),
    rail: $('[data-p="rail"]'), beds: $('[data-p="beds"]'), pieces: $('[data-p="pieces"]'),
    shop: $('[data-p="shop"]'), swatch: $('[data-p="swatch"]'), price: $('[data-p="price"]'),
    prevName: $('[data-p="prevname"]'), nextName: $('[data-p="nextname"]'), hint: $('[data-p="hint"]')
  };

  /* ---------- the 3D rail, when it runs ---------- */
  let api = null;
  const Stage = {
    hoverFromUI: i => api?.hoverFromUI(i),
    focus: i => api?.focus(i),
    unfocus: i => api?.unfocus(i)
  };

  /* ---------- panel ---------- */
  let focusIndex = -1;
  let touchLike = window.matchMedia('(pointer: coarse)').matches;
  function setHint(phone) {
    if (!hint) return;
    hint.textContent = root.classList.contains('is-live') ? ((phone || touchLike) ? data.copy.hintTouch : data.copy.hintPointer) : data.copy.hintStatic;
  }
  function preload(i) {
    const s = shades[(i + N) % N];
    for (const src of [s.close, s.bed]) if (src) { const im = new Image(); im.decoding = 'async'; im.src = src; }
  }
  function fillPanel(i) {
    const s = shades[i];
    el.count.textContent = `${pad(i + 1)} / ${pad(N)}`;
    el.name.textContent = s.name;
    el.note.textContent = s.note || '';
    el.note.hidden = !s.note;
    el.close.src = s.close; el.close.alt = s.closeAlt;
    el.bed.src = s.bed; el.bed.alt = s.bedAlt;
    el.bedCap.textContent = s.bedCap;
    el.rail.textContent = s.rail;
    el.beds.textContent = s.beds;
    el.pieces.textContent = s.pieces;
    el.pieces.closest('div').hidden = !s.pieces;
    el.shop.textContent = s.shopLabel;
    el.shop.href = s.shop;
    el.swatch.hidden = !s.swatch;
    if (s.swatch) el.swatch.href = s.swatch;
    el.price.textContent = s.price;
    el.prevName.textContent = shades[(i - 1 + N) % N].name;
    el.nextName.textContent = shades[(i + 1) % N].name;
    chips.forEach((c, k) => { c.classList.toggle('is-on', k === i); c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
  }
  function openShade(i, fromKey) {
    const was = focusIndex;
    focusIndex = (i + N) % N;
    fillPanel(focusIndex);
    root.classList.add('is-focus');
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    Stage.focus(focusIndex);
    if (was < 0 || fromKey) el.name.focus({ preventScroll: true });
    preload(focusIndex + 1); preload(focusIndex - 1);
  }
  function closeShade() {
    if (focusIndex < 0) return;
    const was = focusIndex;
    focusIndex = -1;
    root.classList.remove('is-focus');
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    chips.forEach(c => { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
    Stage.unfocus(was);
    chips[was]?.focus({ preventScroll: true });
  }
  chips.forEach((b, i) => {
    b.addEventListener('mouseenter', () => Stage.hoverFromUI(i));
    b.addEventListener('focus', () => Stage.hoverFromUI(i));
    b.addEventListener('mouseleave', () => Stage.hoverFromUI(-1));
    b.addEventListener('blur', () => Stage.hoverFromUI(-1));
    b.addEventListener('click', () => openShade(i));
  });
  $('[data-p="closebtn"]').addEventListener('click', closeShade);
  $('[data-p="prev"]').addEventListener('click', () => openShade(focusIndex - 1));
  $('[data-p="next"]').addEventListener('click', () => openShade(focusIndex + 1));
  document.addEventListener('keydown', e => {
    if (focusIndex < 0) return;
    if (e.key === 'Escape') { closeShade(); return; }
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && root.contains(document.activeElement) && !document.activeElement.closest('.sqw__chips')) {
      openShade(focusIndex + (e.key === 'ArrowRight' ? 1 : -1), true);
    }
  });
  $('.sqw__chips').addEventListener('keydown', e => {
    const k = chips.indexOf(document.activeElement);
    if (k < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    e.preventDefault();
    chips[(k + (e.key === 'ArrowRight' ? 1 : -1) + N) % N].focus();
  });

  let capShown = -1;
  function setCaption(i, x, y) {
    if (i < 0 || focusIndex >= 0) { if (capShown !== -1) { caption.classList.add('is-hidden'); capShown = -1; } return; }
    if (capShown !== i) {
      caption.classList.remove('is-hidden');
      capName.textContent = shades[i].name;
      capNum.textContent = `${pad(i + 1)} / ${pad(N)}`;
      capShown = i;
    }
    caption.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) translate(-50%, 0)`;
  }
  function setHover(h) {
    chips.forEach((c, k) => c.classList.toggle('is-on', k === h || k === focusIndex));
  }

  /* ---------- device tier ---------- */
  function detect() {
    const out = { tier: 'off', why: '', gpu: '' };
    if (navigator.connection && navigator.connection.saveData) { out.why = 'data-saver'; return out; }
    let gl = null;
    try { gl = document.createElement('canvas').getContext('webgl2'); } catch (e) { /* no WebGL */ }
    if (!gl) { out.why = 'no-webgl2'; return out; }
    const ext = gl.getExtension('WEBGL_debug_renderer_info');
    const gpu = String(ext ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER));
    const maxTex = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    out.gpu = gpu;
    // software rendering draws the rail at a few frames a second: keep the poster
    if (/swiftshader|llvmpipe|softpipe|basic render/i.test(gpu)) { out.why = 'software'; return out; }
    const mem = navigator.deviceMemory, cores = navigator.hardwareConcurrency || 4;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const weak = /mali-(4|t|g3|g5[0-9]|g7[0-6])\b|adreno \(tm\) ([1-5]\d\d|6[0-1]\d)\b|powervr|intel.*(hd graphics( [2-5]\d\d)?$|hd graphics [2-5]\d\d|gma)/i.test(gpu);
    const modest = /intel.*uhd graphics|intel.*hd graphics 6\d\d|adreno \(tm\) 6[2-4]\d\b|mali-g(5|7)7/i.test(gpu);
    out.tier = coarse ? 'mid' : 'high';
    if (modest) out.tier = 'mid';
    if (weak || maxTex < 4096 || cores <= 2 || (mem && mem <= 2) || (coarse && mem && mem <= 4)) out.tier = 'low';
    out.why = [mem ? `${mem}GB` : 'mem?', `${cores} cores`, coarse ? 'touch' : 'pointer'].join(', ');
    return out;
  }

  /* ---------- start the 3D only once the rail is on screen ---------- */
  let started = false, visible = false, attempts = 0, revealTimer = 0;
  const device = detect();
  if (debug) { const m = location.search.match(/[?&]sqw-tier=(\w+)/); if (m) device.tier = m[1]; }
  root.dataset.sqwTier = device.tier;
  const toStatic = reason => {
    clearTimeout(revealTimer);
    if (api) { try { api.destroy(); } catch (e) { /* already gone */ } api = null; }
    root.classList.remove('is-live', 'is-warming');
    root.classList.add('is-static');
    root.dataset.sqwStatic = reason;
    setHint(false);
    // a lost graphics context (a phone reclaiming memory in the background) gets one fresh start
    if (reason === 'lost' && attempts < 2) { started = false; if (visible && !isHidden()) setTimeout(begin, 600); }
  };
  if (device.tier === 'off') toStatic(device.why);
  setHint(false);

  const whenLoaded = () => document.readyState === 'complete' ? Promise.resolve() : new Promise(r => window.addEventListener('load', r, { once: true }));
  const whenIdle = () => new Promise(r => (window.requestIdleCallback ? requestIdleCallback(r, { timeout: 1500 }) : setTimeout(r, 200)));

  async function begin() {
    if (started || device.tier === 'off') return;
    started = true; attempts++;
    root.classList.remove('is-static');
    root.classList.add('is-warming');
    try {
      await whenLoaded(); await whenIdle();
      const mod = await import(data.module);
      let firstFrame;
      const firstFramePromise = new Promise(r => { firstFrame = r; });
      api = await mod.start({
        stage, poster, intro: $('.sqw__intro'), index: $('.sqw__index'),
        shades: shades.map(s => ({ slug: s.slug, throw: s.throw })),
        assetBase: data.assetBase, tier: device.tier, phone: window.matchMedia('(max-width: 749px)').matches,
        reduceMotion, instantLights: true, debug,
        onFirstFrame: () => firstFrame(),
        report: r => { root.dataset.sqwProbe = JSON.stringify(r); if (debug) console.info('[sqw]', r); },
        ui: {
          hover: setHover, caption: setCaption, open: i => openShade(i),
          panelWidth: () => panel.offsetWidth,
          layout: ({ phone }) => setHint(phone),
          fail: reason => toStatic(reason)
        }
      });
      if (!visible || isHidden()) api.setActive(false);
      // give up on the 3D only after 30 seconds on screen (a tab opened in the background waits)
      const armReveal = () => { revealTimer = setTimeout(() => { if (isHidden() || !visible) armReveal(); else toStatic('timeout'); }, 30000); };
      armReveal();
      const ok = await api.warm();
      if (!ok || !api) return;
      await firstFramePromise;
      clearTimeout(revealTimer);
      root.classList.remove('is-warming');
      root.classList.add('is-live');
      setHint(window.matchMedia('(max-width: 749px)').matches);
      api.reveal();
      if (focusIndex >= 0) api.focus(focusIndex);
      if (debug) window.__sqw = { api, data, device };
    } catch (err) {
      console.error('[Stella Quilt Wall]', err);
      root.dataset.sqwError = String((err && err.message) || err).slice(0, 160);
      toStatic('error');
    }
  }

  const io = new IntersectionObserver(entries => {
    visible = entries[entries.length - 1].isIntersecting;
    if (visible && !started) begin();
    api?.setActive(visible && !isHidden());
  }, { rootMargin: '200px 0px' });
  io.observe(root);
  if (forceVisible) { visible = true; begin(); }
  document.addEventListener('visibilitychange', () => api?.setActive(visible && !isHidden()));
  window.addEventListener('pointerdown', e => { touchLike = e.pointerType === 'touch'; }, { passive: true, capture: true });
  if (debug) window.__sqwDevice = device;
})();
